exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".waterfall-chart-container[data-v-642b8dfa]{margin-top:30px;background-color:#fff;border-radius:8px;padding:20px;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.1);box-shadow:0 2px 4px rgba(0,0,0,.1)}.chart-header[data-v-642b8dfa]{margin-bottom:20px}.chart-header h3[data-v-642b8dfa]{font-size:16px;font-weight:700;color:#333;margin:0}.chart-wrapper[data-v-642b8dfa]{position:relative;height:400px;width:100%}@media (max-width:768px){.chart-wrapper[data-v-642b8dfa]{height:300px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-642b8dfa","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/DashBoard/Report/MediaAnalysis/MediaWaterfallChart.vue
// module id = uNYZ
// module chunks = 3